function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#1B1B1B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M71.413 91.75L0.251 91.75 0.251 0.98 56.164 0.98 71.413 16.108z",
  transform: "translate(1) translate(0 .27)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.84 1.2L55.84 16.39 71.369 16.39",
  transform: "translate(1) translate(0 .27)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M26.44 22.801L26.44 27.839 11.327 27.839 11.327 12.726 26.44 12.726",
  transform: "translate(1)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.007 17.57L20.626 23.189 30.508 13.307M26.44 49.514L26.44 54.551 11.327 54.551 11.327 39.438 26.44 39.438",
  transform: "translate(1)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.007 44.282L20.626 49.901 30.508 40.019M26.44 75.226L26.44 80.264 11.327 80.264 11.327 65.15 26.44 65.15",
  transform: "translate(1)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.007 69.994L20.626 75.613 30.508 65.731M36.004 17.046h11.972M36.004 24.005h11.972M36.004 44.648h21.947M36.004 51.966h21.947M36.004 68.59h21.947M36.004 75.909h21.947",
  transform: "translate(1)"
}));

var SvgBluetoothModule01 = function SvgBluetoothModule01(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 94,
    viewBox: "0 0 74 94",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBluetoothModule01, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bluetooth-module-01.ce5113bc.svg";
export { ForwardRef as ReactComponent };